import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatInputModule, MatCheckboxModule, MatSlideToggleModule, MatTableModule, MatPaginatorModule ,MatSelectModule} from '@angular/material';
import { NgModule } from '@angular/core';
import { EmpresaRoutingModule, ROUTABLE_COMPONENTS } from './empresa.routing';
import { FabButtonGroupModule } from '../../../shared/fabbuttongroup/fabbuttongroup.module';
import { SectionBarModule } from '../../../shared/sectionbar/sectionbar.module';
import { GridEmptyModule } from '../../../shared/gridempty/gridempty.module';
import { AplicacionModule } from '../Aplicaciones/aplicacion.module';

//ccontrols
import { TitlebarModule } from '../../../shared/titlebar/titlebar.module';
import { HeaderModule } from '../../../shared/header/header.module';
import { LoaderModule } from '../../../shared/loader/loader.module';
import { SnackbarModule } from '../../../shared/snackbar/snackbar.module';
import { EmpresaService } from './shared/empresa.service';
import { EmpresaListComponent } from './list/empresa-list.component';
import { EmpresaComponent } from './empresa.component';
import { EmpresaNewComponent } from './new/empresa-new.component';
import { EmrpesaViewComponent } from './view/empresa-view.component';
import { EmpresaEditComponent } from './edit/empresa-edit.component';


@NgModule({
  imports: [
    BrowserModule,
    MatTableModule,
    EmpresaRoutingModule,MatSelectModule,
    MatCheckboxModule, MatButtonModule, MatInputModule, MatPaginatorModule,
    FormsModule, ReactiveFormsModule,
    FabButtonGroupModule, AplicacionModule,
    SectionBarModule, MatSlideToggleModule, GridEmptyModule,
    TitlebarModule, HeaderModule, LoaderModule, SnackbarModule
  ],
  entryComponents: [],
  exports: [],
  declarations: [
    EmpresaEditComponent,
    EmrpesaViewComponent,
    EmpresaNewComponent,
    EmpresaComponent,
    EmpresaListComponent,
    ROUTABLE_COMPONENTS
  ],
  providers: [EmpresaService],
  bootstrap: []
})
export class EmpresaModule {
}
